import { render } from "./RejectBookingRequestModal.vue?vue&type=template&id=234604a6&scoped=true"
import script from "./RejectBookingRequestModal.vue?vue&type=script&lang=js"
export * from "./RejectBookingRequestModal.vue?vue&type=script&lang=js"

import "./RejectBookingRequestModal.vue?vue&type=style&index=0&id=234604a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234604a6"]])

export default __exports__